import { useReducer, useMemo } from "react";
import { useIsoMorphicEffect as n } from "./use-iso-morphic-effect.js";
function f(e) {
  if (e === null) return { width: 0, height: 0 };
  let { width: t, height: r } = e.getBoundingClientRect();
  return { width: t, height: r };
}
function d(e, t = false) {
  let [r, u] = useReducer(() => ({}), {}), i = useMemo(() => f(e), [e, r]);
  return n(() => {
    if (!e) return;
    let n2 = new ResizeObserver(u);
    return n2.observe(e), () => {
      n2.disconnect();
    };
  }, [e]), t ? { width: `${i.width}px`, height: `${i.height}px` } : i;
}
export {
  d as useElementSize
};
